export enum AuthEndpoint {
  Base = '/users',
  Login = '/login',
  Session = '/session',
  Logout = '/logout',
  Refresh = '/login/refresh',
  IdToken = '/id-token',
  PasswordReset = '/password-reset',
  AuthMe = '/auth/me',
}

export enum AvailableRouteWithoutAcceptingDPN {
  DataProtectionNoticeAccept = '/dashboard/administration/data-protection-notice/accept',
  DataProtectionNoticeDefault = '/dashboard/administration/data-protection-notice/default',
  Imprint = '/dashboard/administration/legal-documents/imprint',
  LegalNotice = '/dashboard/administration/legal-documents/legal-notice',
  DependencyLicenses = '/dashboard/administration/dependency-licenses',
}
